import React from 'react';
import { useTranslation } from 'react-i18next';

interface LogoProps {
  className?: string;
  compact?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className = '', compact = false }) => {
  const { t } = useTranslation();

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/logo.png"
        alt=""
        width={36}
        height={36}
        className="h-9 w-9 rounded-lg object-cover"
      />
      {!compact && (
        <span className="flex flex-col leading-none">
          <strong className="text-[0.95rem] font-semibold text-paper">Simpian</strong>
          <em className="mt-0.5 font-display text-xs font-medium italic text-stamp">
            {t('brand.consulting')}
          </em>
        </span>
      )}
    </span>
  );
};

export default Logo;
